import profilePicture from "../assets/Aditya-Portfolio.png";

function Intro({ setDefault, setBlue, setGreen, setPurple }) {
	const btnStyle = { padding: "0", border: "none", background: "none" };

	return (
		<section className="s1">
			<div className="main-container">
				<div className="greeting-wrapper">
					<h1>Hello, I'm Aditya Bhattad</h1>
				</div>

				<div className="intro-wrapper">
					<div className="nav-wrapper">
						<ul id="navigation">
							<li>
								<a href="#contact-form">Contact</a>
							</li>
						</ul>
					</div>
					<div className="left-column">
						<img
							id="profile-pic"
							src={profilePicture}
							alt="Aditya's Profile "
						/>
						<h5 style={{ textAlign: "center", lineHeight: 0 }}>
							Personalize Theme
						</h5>
						<div id="theme-options-wrapper">
							<button style={btnStyle} onClick={setDefault}>
								<div
									data-mode="light"
									id="light-mode"
									className="theme-dot"
								></div>
							</button>
							<button style={btnStyle} onClick={setBlue}>
								<div
									data-mode="blue"
									id="blue-mode"
									className="theme-dot"
								></div>
							</button>
							<button style={btnStyle} onClick={setGreen}>
								<div
									data-mode="green"
									id="green-mode"
									className="theme-dot"
								></div>
							</button>
							<button style={btnStyle} onClick={setPurple}>
								<div
									data-mode="purple"
									id="purple-mode"
									className="theme-dot"
								></div>
							</button>
						</div>

						<p id="setting-note">
							*Theme settings will be saved for <br /> your next
							visit
						</p>
					</div>
					<div className="right-column">
						<div id="preview-shadow">
							<div id="preview">
								<div id="corner-tl" className="corner"></div>
								<div id="corner-tr" className="corner"></div>
								<h3>What I Do?</h3>
								<p>
									I am a sophomore-year computer science
									undergraduate from Nagpur University.
								</p>

								<div id="corner-bl" className="corner"></div>
								<div id="corner-br" className="corner"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default Intro;
